import axios from "axios";
import {config} from "../config";
import GeneralService from "./GeneralService";


export default class UserService {

    static async setDeck(deckId: number) {

        return axios.post(config.serverUrl + '/api/deck/set-active', {id: deckId}, GeneralService.makeHeader())
    }

    static async createDeck(name: string) {

        return axios.post(config.serverUrl + '/api/deck/create', {name: name}, GeneralService.makeHeader())
    }

    static async editDeck(id: number, name: string) {

        return axios.post(config.serverUrl + '/api/deck/update', {name: name, id: id}, GeneralService.makeHeader())
    }

    static async deleteDeck(id: number) {

        return axios.post(config.serverUrl + '/api/deck/delete', {id: id}, GeneralService.makeHeader())
    }

    static async removeCard(cardId: number) {

        return axios.post(config.serverUrl + '/api/editor/remove', {card_id: cardId}, GeneralService.makeHeader())
    }

    static async addCard(cardId: number) {

        return axios.post(config.serverUrl + '/api/editor/add-card', {card_id: cardId}, GeneralService.makeHeader())
    }

    static async editUser(login: string, password: string, username: string) {

        // @ts-ignore
        return axios.put(config.serverUrl + '/api/player/edit', {
                login: login,
                password: password,
                username: username
            }, GeneralService.makeHeader()
        )
    }

    static async openBox(boxId: number) {

        // @ts-ignore
        return axios.post(config.serverUrl + '/api/boxes/open', {
                id: boxId
            }, GeneralService.makeHeader()
        )
    }

    static async craftCard(cardId: number) {
        // @ts-ignore
        return axios.post(config.serverUrl + '/api/workshop/create', {
                id: cardId
            }, GeneralService.makeHeader()
        )
    }

    static async activateSeasonPass() {
        return; //@depretated
        // @ts-ignore
        return axios.post(config.serverUrl + '/api/boxes/season-pass', {}, GeneralService.makeHeader()
        )
    }

    static async getBoxes() {

        // @ts-ignore
        return axios.get(config.serverUrl + '/api/boxes', GeneralService.makeHeader()
        )
    }

    static async getCards() {

        // @ts-ignore
        return axios.get(config.serverUrl + '/api/cards', GeneralService.makeHeader()
        )
    }


    static async getNutakuBoxes() {

        // @ts-ignore
        return axios.get(config.serverUrl + '/api/nutaku/payment/boxes', GeneralService.makeHeader()
        )
    }

    static async sendEvent(event: string) {

        // @ts-ignore
        return axios.post(config.serverUrl + '/api/player/events', {
                event: event,
            }, GeneralService.makeHeader()
        )
    }

    static async resetPassword(email: string) {

       return axios.post(config.serverUrl + '/api/reset-password', {
            email: email,
        })
    }

    static async applyPromocode(promocode: string) {

        return axios.post(config.serverUrl + '/api/shop/promocode', {
            code: promocode,
        }, GeneralService.makeHeader())
    }

    static async authUserByLoginAndPass(login: string, password: string) {

        return axios.post(config.serverUrl + '/api/authbypass?version=' + config.VERSION, {
            login: login,
            password: password
        })
    }

    //

    static async authNewUser() {

        return axios.post(config.serverUrl + '/api/auth-new?version=' + config.VERSION, {
        })
    }

    static async updateUser() {

        return axios.get(config.serverUrl + '/api/player-details?version=' + config.VERSION, GeneralService.makeHeader());

    }

    static async getFiles() {

        // @ts-ignore
        return axios.get(config.serverUrl + '/api/files')
    }
}
